import { render, staticRenderFns } from "./posPaid.vue?vue&type=template&id=5b9be8da&scoped=true&"
import script from "./posPaid.vue?vue&type=script&lang=js&"
export * from "./posPaid.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b9be8da",
  null
  
)

export default component.exports